import type { FC } from "react";
import { Link } from "react-router-dom";

const ICON_URL = "/imgs/cloud.png";

export const Logo: FC = () => {
    return (
        <Link
            to="/"
            id="logo"
            className="inline-block mx-4 box-border"
        >
            <img
                alt="logo-image"
                src={ICON_URL}
                height="25"
            />
        </Link>
    );
};
